import { CSSTransition } from 'react-transition-group';
import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import MessagesList from './components/MessagesList/MessagesList';
import { useMemo, useRef } from 'react';

function App() {
  const {
    currentState,
    isVisible,
    showedMessages,
    setDelay,
    currentMessageRef,
  } = useCarousel();
  const {
    bg,
    phoneNumber,
    socials,
    title,
    qrCode,
    bgColor,
    phoneNumberFontSize,
    titleFontSize,
    authorFontSize,
    msgFontSize,
    user,
  } = useGetParams();

  const advt_info = useMemo(
    () => ({
      qrCode: qrCode,
      label: title,
      number: phoneNumber,
      socials: socials?.split(','),
    }),
    [phoneNumber, socials, title, qrCode]
  );

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg]);

  // контейнер с сообщением, нужен для скролинга текста сообщения в useScrollText
  const messagesRef = useRef(null);

  return (
    <div className="app-wrapper" style={{ background }}>
      <CSSTransition
        in={isVisible && showedMessages && currentState === 'S1'}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
        nodeRef={messagesRef}>
        <div ref={messagesRef}>
          <MessagesList
            messages={showedMessages}
            advtInfo={advt_info}
            setDelay={setDelay}
            messagesWrapper={messagesRef.current}
            currentMessageRef={currentMessageRef}
            phoneNumberFontSize={phoneNumberFontSize}
            titleFontSize={titleFontSize}
            authorFontSize={authorFontSize}
            msgFontSize={msgFontSize}
            user={user}
          />
        </div>
      </CSSTransition>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
